function humanizeList(items: string[]): string {
    const size = items.length;

    if (size === 1) {
        return items[0];
    }

    let renderStr = "";

    for (let i = 0; i < size; i++) {
        if (i === size - 1) {
            renderStr += " e ";
        } else if (i !== 0) {
            renderStr += ", ";
        }
        renderStr += items[i];
    }

    return renderStr;
}

export default humanizeList;
